import { Pin, PinThemePinSettings, PinThemePinSettingsSchema } from '@lessonup/pins-shared';
import { UnionToTuple } from '@lessonup/utils';

export type PinThemePinSchemaReturnTypes = {
  [K in keyof PinThemePinSettings]: UnionToTuple<keyof PinThemePinSettings[K]>;
};

export const pinThemePinSchemaReturnTypes = PinThemePinSettingsSchema.keyof().options.reduce(
  (acc, key) => ({
    ...acc,
    [key]: PinThemePinSettingsSchema.shape[key].keyof().options,
  }),
  {} as PinThemePinSchemaReturnTypes
);

export function getResetablePinSettings(pin: Pin) {
  return pinThemePinSchemaReturnTypes[pin.type];
}
